const maxFilesPerNetwork = {
 facebook: 20,
 instagram: Infinity,
 linkedin: 20,
 google: 1,
 threads: 10,
 twitter: 4,
 tiktok: 1,
 youtube: 1,
 pinterest: 1,
 telegram: 0
};

const formDataDefault = {
    planifiedDate: {
        date: false,
        hours: false,
        timestamp: false
    },
    textContent: "",
    mentions: {},
    idMentionSelected : null,
    textComment: '',
    urlsTextContent:[],
    urlsTextContentHistory: new Set([]),
    files : [],
    formDataNetwork: {
        facebook: {
            snippet: {
                link: '',
                title: "",
                description: "",
                imageUrl:""
            },
            typeMedia : 'image',
            place : null,
        },
        instagram: {
            personsIdentified : [],
            collaborators : [],
            music : null,
            place : null,
            ratio : "1:1",
            shareInStory: false
        },
        linkedin: {
            typeMedia : 'image',
            survey : {
                active : false,
                duration: 'threeDay',
                question : 'Aimes-tu les chats ?',
                options : ['Oui','Non']
            },
            pdf : {
                title : ''
            },
            snippet: {
                link: '',
                title: '',
                imageUrl: ''
            },
        },
        threads: {
            snippet: {
                link: '',
                imageUrl: ''
            },
        },
        twitter: {
            typeContent : 'image',
            snippet: {
                link: '',
            },
        },
        tiktok: {
            visibility : 'all',
            commentDisable: false,
            useVideoForDuo: true,
            useVideoForOtherVideo: true
        },
        google: {
            snippet: {
                link: '',
            },
        },
        telegram: {},
        pinterest: {
            snippet: {
                link: '',
            },
            boardSelectedByPage : {}
        },
        youtube: {
            visibility : 'all',
            category : "22",
            notifySubscribers: true,
            contentForChildren: false,
            tags : [],
            playlistSelectedByPage : {}
        }
    },
    storification : {
        background : {
            file : {
                file : {
                    type:'image/jpeg',
                },
                url : 'https://i.pinimg.com/236x/84/bd/bc/84bdbc1507a0697fe9288477342b2005.jpg', //temporaire
            }, //temporaire
           
            color : '#f8f1e0',
            size : 'containY', // 'cover' | 'containX' | 'containY'
            position: {"x":50,"y":50},
            transform: {"rotate":0,"scale":1}
            
        },
        stickers : {}
    }
        
}

export { 
    maxFilesPerNetwork,
    formDataDefault
};
  



